import React, { useEffect, useState } from 'react';
import { ClassCard } from '../../StudentDashboard/styles';
import { Box, Button, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useGetClassDate from '../../../Infrastructure/CustomHooks/useGetClassDate';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import useAuthentication from '../../../Infrastructure/States/onAuthStateChange';
import { USER_LOGS_CLIENT } from '../../../Infrastructure/Constants/logsConstant';
import paths from "../../../Infrastructure/Router/paths";
import { safeClientLogEvent } from '../../../Infrastructure/Utilities/safeClientLogEvent';
import { classItemSx } from './styles';

dayjs.extend(utc);
dayjs.extend(timezone);

export const ClassItem = ({ classData, serverNow, onClick, handleRefund, handleTryAgainPayment }) => {
  const navigate = useNavigate();
  const {userId} = useAuthentication()
  const courseTitle = classData?.course_title;
  const cohort = classData?.cohort;
  const classUrl = classData?.class_url;
  const [loading, setLoading] = useState(true);
  const [isEligibleForRefund, setIsEligibleForRefund] = useState(false)
  const firstClass = useGetClassDate(classData?.first_class);
  const lastClass = useGetClassDate(classData?.last_class);
  const isClassStatusIsActive = classData?.class_status === "active"

  const isActive = isClassStatusIsActive && classData?.payment_status === "success" && serverNow >= classData?.first_class &&
    serverNow <= classData?.last_class;
  
  const canShowTryAgainButton = 
    classData?.payment_status === "failed" &&
    classData?.class_status === "active" &&
    classData?.course_status === "active" &&
    serverNow <= classData.class_expiration_time;

  const handleEnterClassroom = async (courseTitle, cohort) => {
    try {
      navigate(paths.room.path + `/${classUrl}`);
      await safeClientLogEvent({
        ...USER_LOGS_CLIENT.CLASSROOM_ENTERED,
        uid: userId || null,
        source: "classItem.jsx",
        emailInfo: null,
        metadata: { 
          courseTitle, 
          cohort, 
          classUrl 
        },
        error: null
      });
    } catch (error) {
      await safeClientLogEvent({
        ...USER_LOGS_CLIENT.SERVER_TIME_NOT_RETRIEVED,
        uid: userId || null,
        source: "classItem.jsx",
        emailInfo: null,
        metadata: null,
        error: error?.message || null
      });
    }
  };
  useEffect(() => {
    const currentTime = serverNow ?? Date.now()
    if (classData?.refund_time) {
      setIsEligibleForRefund(currentTime <= classData.refund_time);
    }

    setLoading(false);
  }, [serverNow, classData]);
  return (
    <ClassCard position='relative'>
      {/* Status Display */}
      {classData?.payment_status === "pending" || classData?.payment_status === "failed" ?
      <Box sx={{ ...classItemSx.statusBox, bgcolor: classData?.payment_status === "failed" ? "red" : "grey" } }>
        <Typography sx={classItemSx.statusText}>
          {classData?.payment_status === 'failed' ? "Payment Failed" : classData?.payment_status}
        </Typography>
      </Box>
      : 
      <Box sx={classItemSx.statusPlaceholder} />
      }
      <Tooltip title={courseTitle} placement="top" enterTouchDelay={0}>
        <Typography sx={classItemSx.courseTitle} color={'secondary'}>
          {courseTitle}
        </Typography>
      </Tooltip>
      <Typography sx={classItemSx.cohortText} color={'primary'}>
        Cohort# {cohort}
      </Typography>
      <Typography sx={classItemSx.dateText} color={'primary'}>
        {firstClass?.month}/{firstClass?.weekday}/{firstClass?.year} - {lastClass?.month}/{lastClass?.weekday}/{lastClass?.year}
      </Typography>
        {/* Show Enter Classroom button if class is active and payment is active */}
        {isActive && (
          <Button
              variant='contained'
              type='button'
              sx={classItemSx.enterButton}
              onClick={()=>handleEnterClassroom(courseTitle, classData?.cohort)}
            >
              Enter Classroom
            </Button>
          )}
      <Button variant='contained' type='button' sx={classItemSx.detailsButton} onClick={onClick}>
        Details
      </Button>

      {/* conditional buttons / placeholders */}
      <Box sx={classItemSx.buttonWrapper}>
        {canShowTryAgainButton ? (
          <Button
            variant="contained"
            type="button"
            onClick={handleTryAgainPayment}
            sx={classItemSx.tryAgainButton}
          >
            Try Again
          </Button>
        ) : loading ? (
          <CircularProgress size={20} />
        ) : isEligibleForRefund && classData?.payment_status !== "failed" ? (
          <Button
            variant="contained"
            type="button"
            onClick={() => handleRefund({
              classId: classData?.class_id,
              courseId: classData?.course_id,
              educatorId: classData?.educator_id
            })}
            sx={classItemSx.refundButton}
          >
            Cancel
            </Button>
          ) : (
            <Box sx={classItemSx.placeholderBox} />
          )}
      </Box>

    </ClassCard>
  );
};
